import { useState } from 'react';

const useToast = () => {
  const [toast, setToast] = useState({
    show: false,
    title: 'Notification',
    message: '',
    variant: 'success',
    delay: 4000,
    position: 'top-center',
  });

  const showToast = ({
    title = 'Notification',
    message,
    variant = 'success', // 'success', 'error', 'warning'
    delay = 4000,
    position = 'top-center',
    actions = null, // Optional: [{ label, onClick, variant }]
    autoHide = true
  }) => {
    setToast({
      show: true,
      title,
      message,
      variant,
      delay,
      position,
      actions,
      autoHide: actions ? false : autoHide // Don't auto-hide if there are action buttons
    });
  };

  const hideToast = () => {
    setToast(prev => ({ ...prev, show: false }));
  };

  return {
    toast,
    showToast,
    hideToast,
  };
};

export default useToast;